<template>
  <div >
    <transition name="el-fade-in-linear" mode="out-in">
      <div class="col-md-12" >  
        <div class="row">

          <div class="col-md-12 card" :data-background-color="'slateblue'">
            <img v-if="appl && appl.owner.name != 'WES'" class="partnerLogo" :src="appl.logo"/>
            <img v-if="appl && appl.owner.name == 'WES'" class="wesPartnerLogo" :src="appl.logo"/>
            <div class="card-header" v-if="appl.owner.name == 'WES'">
                <h4 class="card-title">The Fastest and Easiest Way to Verify Your Qualifications</h4>
            </div>
            <div class="card-header" v-else>
                <h4 class="card-title">Qualification Verification for your application to {{appl ?  appl.owner.name : 'the organisation'}}.</h4>
            </div>
            <div class="card-content col-md-12">
              <div v-if="!appl.owner.name == 'WES'">
                <p>Please complete your application which will be shared along with your verification results to {{appl ? appl.owner.name : 'the organisation.'}}.</p>
              </div>
              <div v-if="appl.owner.name == 'Teesside University'">
                <div>Want some guidance on with how to submit your application? Watch our How To video here...</div>
                <iframe class="youtube-video" style="max-width: 560px" src="https://www.youtube.com/embed/QigYnF633zM?si=qf48Ghr8S-4uwTk5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
              <div v-if="appl.owner.name == 'WES'">
                <p>Thanks for choosing the hassle-free way to verify your qualifications! We work in partnership with WES to speed up the process and ensure you are ready to start your studies without delay.</p>
                <p>In just a few clicks and for a small fee, we will start processing your verification request by directly engaging with your educational institution to authenticate your documents.</p>
                <p>Why Choose Us?
                  <ul>
                    <li>Save Time: Cut down the waiting time and reduce the risk of missing deadlines.</li>
                    <li>Expert Help: Our experienced team handles everything for you.</li>
                    <li>Security: We transmit your documents securely, directly to WES.</li>
                  </ul>
                </p>
                <p>
                  <b>Step 1:</b> Upload your documents.</br>
                  <b>Step 2:</b> Sit back—our team takes care of everything!</br>
                  <b>Step 3:</b> We send your verified documents and verification results to WES digitally.</br>
                </p>
              </div>
            </div>
          </div>
          <div v-if="appl && appl.description" data-notify="container" class="col-md-12 alert alert-warning alert-with-icon">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message" style="font-size: 120%"> {{ appl.description }}</span>
          </div>
        </div>

        <application-view v-if="appl" :initApplication="appl" :inflow="true" />
      </div>
    </transition>
    <slot name="actions" :valid="valid" :application="appl" />
  </div>
</template>

<script>
  import Application from 'src/views/Applications/View'
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import LogRocket from 'logrocket';
  import {version} from '../../../../package.json';
  
  export default {
    name: "inflow-application",
    components: {
      'application-view': Application,
      DynamicInput
    },
    inject: ['$validator'],
    props: {
      initApplication: {type: Object, default: null}
    },
  data() {
    return {
      appl: null,
      stepCards: [
        { icon: 'fa fa-pencil', text: 'Submit Details & Upload Official Documents' },
        { icon: 'fa fa-clipboard', text: 'QC will handle the Verification Process & you can track progress via this QC Portal' },
        { icon: 'fa fa-paper-plane', text: 'Once the process is complete, QC will send both verified documents and the verification results to WES in a digital format' }
      ]
    }
  },
  created() {
      this.$validator.extend('requiredDoc', {
        validate(value, args) {
          return value
        },
        getMessage(field, args) {
          return "This document is required"
        } 
      })
      this.appl = this.initApplication
      this.$service.buildApplicationDocuments(this.appl)
    },
    computed: {
      valid() {
        if(!this.appl) {
          return false
        }
        if(this.$validator.errors.any()) {
          return false
        }
        return true
      }
    },
    methods: {
    }
  }
</script>

<style scoped>

.partnerLogo {
  float: right; 
  max-width: 20% !important; 
  max-height: 100px !important; 
  object-fit: contain;
  margin-top: 10px;
  margin-bottom: 10px;
}
.wesPartnerLogo {
  float: right; 
  max-width: 20% !important; 
  max-height: 100px !important; 
  object-fit: contain;
  margin-top: 10px;
  margin-bottom: 10px;
  filter: brightness(0) invert(1);
  
}

.icon-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  text-align: center;
  grid-gap: 20px;
}

.card {
  border: 1px solid #ccc;
  padding: 10px;
}

</style>